// extracted by mini-css-extract-plugin
export var box = "ConsentModal-module--box--1031f";
export var box_md = "ConsentModal-module--box_md--8ab73";
export var box_xmd = "ConsentModal-module--box_xmd--a091b";
export var box_flex = "ConsentModal-module--box_flex--04492";
export var box_lg = "ConsentModal-module--box_lg--581f3";
export var box_sm = "ConsentModal-module--box_sm--3c28a";
export var box_outer = "ConsentModal-module--box_outer--dcf46";
export var box_whiteBg = "ConsentModal-module--box_white-bg--3db94";
export var box_noMarginBottom = "ConsentModal-module--box_no-margin-bottom--123ed";
export var box_noPadding = "ConsentModal-module--box_no-padding--6c28b";
export var box_outerGray = "ConsentModal-module--box_outer-gray--476f0";
export var box_dark = "ConsentModal-module--box_dark--2048a";
export var box_zIndex = "ConsentModal-module--box_z-index--6d22f";
export var box_zIndex6 = "ConsentModal-module--box_z-index-6--48dad";
export var box_eventsWithLine = "ConsentModal-module--box_events-with-line--f102a";
export var box_featuresAo = "ConsentModal-module--box_features-ao--424a2";
export var box_verticalPaddings = "ConsentModal-module--box_vertical-paddings--e63e8";
export var clearP = "ConsentModal-module--clearP--54c08";
export var clearP_vc = "ConsentModal-module--clearP_vc--5fbbd";
export var description = "ConsentModal-module--description--6c88b";
export var button = "ConsentModal-module--button--92a04";
export var fadeInAnimation = "ConsentModal-module--fadeInAnimation--81c9d";
export var placeHolderShimmer = "ConsentModal-module--placeHolderShimmer--dfec6";